<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <switcher label-size="xs" :bg-color="$root.$colors.primary" :label="$lang.onOff.toUpperCase()" :bg-color-lightness="$root.$colors.bgColorLightness" v-model="$root.nightShift" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24"></flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageNightshift'
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/nightshift.vue